<!--
 * @Author: Gaho
 * @Date: 2024-01-15 18:17:55
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-15 14:59:26
 * @Description: 
-->
<template>
    <NuxtLayout name="casino">
        <div class="corgiwild-game">
            <div class="game-container">
                <div class="game-main">
                    <div class="game-section">
                        <div class="game-row">
                            <!-- 顶部菜单 start -->
                            <ClientOnly fallback-tag="span">
                                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
                                    <GameSettingsButtonLiveChat
                                        v-if="userStore.isLoggedIn"
                                        v-model="isOpenLiveChat"
                                    />
                                    <GameSettingsButtonAnimate v-model="settingStore.animation" />
                                    <GameSettingsButtonFast v-model="gameStore.corgiwild.fast" />
                                    <GameSettingsButtonFairness v-model="isOpenFairness" />
                                    <Rules v-model="isOpenRule" name="corgiwild" />
                                    <GameSettingsButtonVocie
                                        v-model="settingStore.inhouseGames.sound.on"
                                        v-model:voice-model-value="
                                            settingStore.inhouseGames.sound.music
                                        "
                                        :saveAfterChange="true"
                                    />
                                </GameSettingsDiceTabsWrapper>
                            </ClientOnly>
                            <ClientOnly>
                                <div class="game-col-corgiwild">
                                    <!-- 游戏展示区域 -->
                                    <div class="corgiwild-main">
                                        <!-- 游戏背景&游戏卡片 -->
                                        <Board
                                            :isAnimate="settingStore.animation"
                                            class="no-popup"
                                            :resResult="resResult"
                                            :musicControler="musicControler"
                                            :showBg="true"
                                            :ref="el => (wildBoard=el)"
                                        />
                                    </div>
                                    <!-- 下注区域 -->
                                    <div>
                                        <CasinoBetOptionSection
                                            v-if="autoBetToolKit || betTookit"
                                            :betTookit="betTookit && betTookit"
                                            :auto-bet-tool-kit="autoBetToolKit && autoBetToolKit"
                                            v-model:bet-amount-modal-value="oForm.amount"
                                            v-model:is-submiting="oForm.isSubmiting"
                                            :is-auto="gameStore?.corgiwild.auto.default"
                                            :bet-submit="betSubmit"
                                            :is-fast="gameStore?.corgiwild.fast"
                                            class="game-body"
                                            @change-mode="toChangeMode"
                                        />
                                    </div>
                                    <!-- 自动 -->
                                    <div class="q-mt-md game-auto">
                                        <CasinoAutoSection
                                            :ref="(el) => (oAutoDialog = el)"
                                            v-model:amount="oForm.amount"
                                            :is-fast="gameStore.corgiwild.fast"
                                            :is-submiting="oForm.isSubmiting"
                                            :is-auto="gameStore.corgiwild.auto.default"
                                        />
                                    </div>
                                    <!-- 游戏结果 -->
                                    <Result
                                        v-if="showResult"
                                        :isFast="gameStore?.corgiwild?.fast"
                                        :isAnimate="settingStore?.animation"
                                        :winType="winType"
                                        :multi="resResult?.multi"
                                        :result="resResult"
                                    />
                                </div>
                            </ClientOnly>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>
<script lang="ts" setup>
// stores & sockets
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import { useGameSocket } from '@/socket/game';
import { useJoinStateStore } from '@/stores/cansino/joinState';
// functions
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
// components
import Board from './_components/board/index.vue';
import Result from './_components/result/index.vue';
import Rules from './_components/rules/index.vue';
// mocks
import { corgiWildConfig } from './data';
import { showTips4BadAmountIfNeeded } from '~/common/js/betHelper';

const joinStore = useJoinStateStore();
const userStore = useUserStore();
const gameStore = useSettingsStore().game;
const settingStore = useSettingsStore();
const isOpenLiveChat = ref(false);
const isOpenRule = ref(false);
const isOpenFairness = ref(false);
const oForm = ref({
    amount: 0,
    isSubmiting: false,
});
const autoBetToolKit = ref(null);
const betTookit = ref(null);
const oAutoDialog = ref(null);
const musicControler = ref(null);
const resResult = ref(null); // 下注结果
const timerResult = ref(null);
const soundOptions = ref({});
const showResult = ref(false); // 是否显示赢分结果弹框
const wildBoard = ref(null); // 是否显示赢分结果弹框

// 赢分类型
const winType = computed(() => {
    const {
        wins: { win, bigWin },
    } = corgiWildConfig;
    return resResult.value.multi < win
        ? 'win'
        : (
            resResult.value.multi < bigWin
            ? 'bigWin'
            : 'megaWin'
        );
});

/**
 * 获取mp3资源，并初始化游戏音效
 */
const loadResource = () => {
    const corgiwildMp3s = import.meta.glob('@/assets/mp3/corgiwild/*.mp3', { eager: true });
    Object.entries(corgiwildMp3s).forEach(([key, value], index) => {
        const keyArr = key.split('/');
        const soundTitle = keyArr[keyArr.length - 1].split('.')[0];
        if (soundTitle.includes('BG')) {
            soundOptions.value[soundTitle] = {
                src: value.default,
                loop: true,
                isBGM: true,
            };
        } else {
            soundOptions.value[soundTitle] = {
                src: value.default,
            };
        }
    });
    // 音效初始化
    musicControler.value = new MusicControler(soundOptions.value);
};
/**
 * 关闭赢分结果弹框
 */
const closeResult = () => {
    timerResult.value && clearTimeout(timerResult.value);
    showResult.value = false;
};
/**
 * 下注
 */
const betSubmit = async () => {
    const { currencies, currentCurrency } = userStore;
    const { EMIT_CORGIWILD_BET } = useGameSocket();
    if (!currencies[currentCurrency].balance) {
        return;
    }
    const isAuto = Boolean(gameStore?.corgiwild.auto.default); 
    if (!isAuto) {
        joinStore.gameRunning = true;
    }
    const params = {
        amount: oForm.value.amount.beFixed(2),
        isFast: gameStore.corgiwild.fast,
        isAnimation: settingStore.animation,
        frontID: new Date().getTime(),
    };
    // if (import.meta.env.DEV_MODE && isAuto && Math.random() <= 0.3){ 
    //     params.amount = '0'; 
    // }
    try {
        const ts = userStore.queueStart(); // 防止余额立即变化
        const res = await EMIT_CORGIWILD_BET(params);
        if (res && !res?.['error'] && !res?.code) {
            const animationOn = Boolean(settingStore?.animation);
            const isFast = Boolean(gameStore?.corgiwild?.fast);
            resResult.value = res.response;
            await nextTick(); // handleAnimation(); 执行前一定要等待 
            await wildBoard.value.handleAnimation(); 
            joinStore?.showDateInQueue(); // 插入游戏结果并播放动画
            userStore?.queueForward(ts); // 显示余额变化
            showResult.value = !!resResult.value.multi;
            // 赢分-则显示游戏结果弹框
            if (showResult.value) {
                // 显示游戏结果弹框
                const defaultDelay = animationOn
                    ? (isFast ? 1500 : 3000)
                    : 1500;
                const megaDelay = animationOn
                    ? (isFast ? 5000 : 7000)
                    : 1500;

                // 播放对应的音频
                if (winType.value === 'megaWin') {
                    isFast
                        ? musicControler.value?.oAudio.FWildMegaWinFast.toPlay()
                        : musicControler.value?.oAudio.FWildMegaWin.toPlay();
                } else {
                    isFast
                        ? musicControler.value?.oAudio.FWildBigWinFast.toPlay()
                        : musicControler.value?.oAudio.FWildBigWin.toPlay();
                }
                const {promise, resolve} = createPromise();
                // 关闭游戏结果弹框
                timerResult.value = setTimeout(
                    () => {
                        closeResult();
                        resolve(); 
                    },
                    winType.value === 'megaWin' ? megaDelay : defaultDelay,
                );
                await promise;
                if (!isAuto) {
                    joinStore.gameRunning = false;
                }
                return {
                    amount: oForm.value.amount.beFixed(2),
                    winAmount: res.response.winAmount,
                };
            }
            if (!isAuto) {
                joinStore.gameRunning = false;
            }
            return {
                amount: oForm.value.amount.beFixed(2),
                winAmount: res.response.winAmount,
            };
        } else {
            userStore.queueDelete(ts);
            isAuto || showNegativeNotify(res?.['error']);
            joinStore.gameRunning = false;
            return res; 
        }
    } catch (error) {
        userStore.queueDelete(ts);
        console.log(error, 'corgiwildGame-error');
        joinStore.gameRunning = false;
    }
};

// ↓ 自动模式输入面板“窗口化改造” 添加的变量与方法：
const toChangeMode = (isAuto) => {
    // ↓按各个游戏的实际情况设定
    gameStore.corgiwild.auto.default = !!isAuto;
    if (isAuto) {
        oAutoDialog.value.switchAutoDialogVisible(true);
    }
};
watch(
    () => settingStore.inhouseGames.sound.on,
    (newVal) => {
        if (newVal) {
            if (!musicControler.value) {
                loadResource();
            }
            musicControler.value.oAudio.FWildBG.toPlay();
        } else {
            musicControler.value?.oAudio.FWildBG.stop();
        }
    },
    {
        immediate: true,
    },
);
// 监听金额变化
watch([oForm.value], ([newVal1]) => {
    if (import.meta.server) return;
    // 固定值 最高倍数1000
    const corgiwildMaxWin = Number(oForm.value.amount.beFixed(2)) * Number(1_000); 
    // ↓ 调取 查询当前游戏当前币种最大赔付金额
    showTips4BadAmountIfNeeded(corgiwildMaxWin)
},{
    deep:true,
    immediate:true
});

onMounted(() => {
    autoBetToolKit.value = useAutoBetToolKit(oForm.value, betSubmit.bind(this));
    betTookit.value = useBettingToolkit(oForm.value);
    onUnmounted(() => {
        musicControler.value?.toDestory();
    });
});
</script>
<style lang='scss' scoped>
.corgiwild-game {
    width: 100%;
    height: 100%;
    padding: 0 0 34px;
    min-height: 400px;
    @media (max-width: 1000px) {
        padding-bottom: 15px;
        padding-top: 3px;
    }
    @media (max-width: 768px) {
        padding-bottom: 10px;
        padding-top: 2px;
    }

    .game-container {
        margin: 0 auto;
        max-width: 1088px;
        position: relative;
        width: 100%;

        @media (max-width: 768px) {
            padding-left: 4px;
            padding-right: 4px;
        }
        .game-main {
            // height: calc(100vh - 112px);
            position: relative;
            opacity: 1;
            height: auto;

            .game-section {
                display: flex;
                justify-content: center;

                .game-row {
                    flex: auto;
                    max-width: 650px;
                    width: 100%;
                    height: 100%;

                    .game-col-controls {
                        width: 100%;
                        max-width: 650px;
                        margin: 0 auto;

                        .button-settings {
                            cursor: pointer;
                            display: flex;
                            justify-content: flex-end;
                            margin-bottom: 12px;
                            margin-top: 2px;
                            width: 100%;

                            & > :deep(div) {
                                flex: none;

                                &:not(:last-child) {
                                    margin-right: 5px;
                                }
                            }
                        }

                        @media (max-width: 1000px) {
                            .button-settings {
                                justify-content: flex-start;

                                & > :deep(div) {
                                    flex: 1;
                                }
                            }
                        }
                    }

                    .game-col-corgiwild {
                        // height: 100%;
                        width: 100%;
                        user-select: none;

                        .corgiwild-main {
                            position: relative;
                            border-radius: 10px;
                            position: relative;
                            width: 100%;
                            height: auto;
                        }
                        .game-auto {
                            display: flex;
                            justify-content: center;

                            @media (max-width: 1100px) {
                                margin-bottom: 0;
                                margin-top: 0px;
                                :deep(.RTP-body) {
                                    margin-top: 16px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>